module.exports = "/_next/static/pages/about/Fragments/901ca08d7cb7273c7d6a182c1d51c035.jpg";